const recaptchaKey = process.env['NX_RECAPTCHA_KEY'];

export const RecaptchaScript = () => {
  const script = document.createElement('script');
  script.src =
    'https://www.google.com/recaptcha/enterprise.js?render=' + recaptchaKey;
  script.async = true;

  return script;
};
